import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-yandex', 'IconBrandYandex', [
  [
    'path',
    { d: 'M15 20v-16h-2a4 4 0 0 0 -4 4v1a4 4 0 0 0 4 4h2', key: 'svg-0' },
  ],
  ['path', { d: 'M9 20l3 -7', key: 'svg-1' }],
]);
